/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { GetAirportResponse } from '../models/get-airport-response';

/**
 * airport apis
 */
@Injectable({ providedIn: 'root' })
export class AirportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllAirport()` */
  static readonly GetAllAirportPath = '/api/v1/airports';

  /**
   * Get list of airport.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllAirport()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAirport$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - icao
       * - name
       * - city
       * - country
       * - iata
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetAirportResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      AirportService.GetAllAirportPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetAirportResponse>;
        })
      );
  }

  /**
   * Get list of airport.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllAirport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllAirport(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to the following fields:
       * - icao
       * - name
       * - city
       * - country
       * - iata
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetAirportResponse> {
    return this.getAllAirport$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<GetAirportResponse>): GetAirportResponse =>
          r.body
      )
    );
  }
}
